<template>
    <div class="form-container card shadow-sm p-3">
      <!-- Cabeçalho -->
      <div class="header d-flex justify-content-between align-items-center">
        <h4 class="form-title">
          {{ entrada.id ? `Editar Entrada nº ${entrada.id}` : 'Nova Entrada' }}
        </h4>
        <button class="btn btn-secondary" @click="cancelar">Voltar</button>
      </div>
  
      <div class="spacer"></div>
      <p v-if="erroProdutos" role="alert" class="alert alert-danger">{{ erroProdutos }}</p>
      <p v-else-if="produtosCarregados && !produtos.length" role="status" class="alert alert-info">Nenhum produto ativo disponível.</p>
      <p v-if="erroContas" role="alert" class="alert alert-danger">{{ erroContas }}</p>
      <p v-else-if="contasCarregadas && !contasFinanceiras.length" role="status" class="alert alert-info">Nenhuma conta disponível nesta escola.</p>
  
      <!-- Seção 1: Dados do Fornecedor -->
      <div class="form-section">
        <h5 class="section-title">Dados do Fornecedor</h5>
        <div class="row">
          <!-- Nota Fiscal -->
          <div class="col-md-2">
            <div class="form-group">
              <label for="nota_fiscal">Nota Fiscal</label>
              <input
                id="nota_fiscal"
                type="text"
                v-model="entrada.nota_fiscal"
                class="form-control"
                placeholder="Número da NF"
              />
            </div>
          </div>
          <!-- Fornecedor -->
          <div class="col-md-5">
            <div class="form-group">
              <label>Fornecedor <span class="required">*</span></label>
              <div class="d-flex">
                <input
                  type="text"
                  class="form-control pessoa-input disabled-input"
                  :value="entrada.fornecedor_nome || ''"
                  disabled
                  required
                />
                <button
                  class="btn btn-primary pessoa-icon-btn"
                  type="button"
                  @click="abrirModalFornecedor"
                >
                  <i class="bi bi-person"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Seção 2: Itens de Entrada -->
      <div class="form-section">
        <h5 class="section-title">Itens de Entrada</h5>
        <table class="table table-borderless">
          <thead>
            <tr>
              <th style="width: 50%;">Produto <span class="required">*</span></th>
              <th style="width: 10%;">Qtd. <span class="required">*</span></th>
              <th>Preço Unit.</th>
              <th>Subtotal</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in entrada.itens" :key="idx">
              <td>
                <select
                  v-model.number="item.produto_id"
                  @change="selecionarProduto(idx)"
                  class="form-control"
                  required
                >
                  <option value="">Selecione</option>
                  <option
                    v-for="p in produtos"
                    :key="p.id"
                    :value="p.id"
                  >
                    {{ p.texto }}
                  </option>
                </select>
              </td>
              <td>
                <input
                  type="number"
                  v-model.number="item.quantidade"
                  min="1"
                  class="form-control"
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  v-model="item.preco_unit_str"
                  class="form-control"
                  @input="onPrecoUnitInput($event, idx)"
                  @blur="formatPrecoUnit(idx)"
                  placeholder="0,00"
                  required
                />
              </td>
              <td>
                <input
                  type="text"
                  :value="formatDecimal(item.subtotal)"
                  class="form-control"
                  readonly
                />
              </td>
              <td class="text-center">
                <button @click="removerItem(idx)" class="btn btn-danger btn-sm">
                  🗑️
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between align-items-center mt-2">
          <button @click="adicionarItem" class="btn btn-primary">
            <i class="bi bi-plus"></i>
          </button>
          <div><strong>Total: R$ {{ formatDecimal(totalEntrada) }}</strong></div>
        </div>
      </div>
  
      <!-- Seção 3: Pagamentos -->
      <div class="form-section">
        <h5 class="section-title">Detalhes do Pagamento</h5>
        <div class="row align-items-start">
          <div class="col-md-2">
            <div class="form-group">
              <label for="data_entrada">Data da Entrada <span class="required">*</span></label>
              <input
                id="data_entrada"
                type="date"
                v-model="entrada.data_entrada"
                class="form-control"
                required
              />
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-group">
              <label for="parcelas">Parcelas</label>
              <input
                id="parcelas"
                type="number"
                v-model.number="parcelasCount"
                min="1"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label>Pendente</label>
              <div class="d-flex align-items-center">
                <input
                  id="pendente"
                  type="checkbox"
                  class="form-check-input me-2"
                  v-model="entrada.pendente"
                />
                <span>{{ entrada.pendente ? 'Sim' : 'Não' }}</span>
              </div>
            </div>
          </div>
        </div>
  
        <div class="table-responsive mb-3" v-if="!entrada.pendente">
          <table class="table table-borderless">
            <thead>
              <tr>
                <th>Parcela</th>
                <th>Forma de Pagamento</th>
                <th>Vencimento<span class="required">*</span></th>
                <th>Valor</th>
                <th>Pagamento<span class="required">*</span></th>
                <th>Conta Financeira<span class="required">*</span></th>
                <th v-if="showChequeCols">Banco nº<span class="required">*</span></th>
                <th v-if="showChequeCols">Agência<span class="required">*</span></th>
                <th v-if="showChequeCols">Cheque nº<span class="required">*</span></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(p, i) in parcelasArray" :key="i">
                <td>{{ i + 1 }}</td>
                <td>
                  <select
                    v-model.number="p.forma_pagamento_id"
                    @change="onParcelaChange(p)"
                    class="form-control"
                    required
                  >
                    <option value="">Selecione</option>
                    <option v-for="fp in formasPagamento" :key="fp.id" :value="fp.id">
                      {{ fp.nome }}
                    </option>
                  </select>
                </td>
                <td>
                  <input type="date" v-model="p.data_vencimento" class="form-control" required />
                </td>
                <td>
                  <input
                    type="text"
                    :value="formatDecimal(p.valor)"
                    class="form-control"
                    readonly
                  />
                </td>
                <td>
                  <template v-if="isAInformar(p.forma_pagamento_id)">
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      value="A informar"
                    />
                  </template>
                  <template v-else>
                    <input
                      type="date"
                      v-model="p.data_pagamento"
                      class="form-control"
                    />
                  </template>
                </td>

                <td>
                  <select
                    v-model.number="p.conta_financeira_id"
                    class="form-control"
                    :disabled="isAInformar(p.forma_pagamento_id)"
                    :required="!isAInformar(p.forma_pagamento_id) && !!(p.data_pagamento && p.data_pagamento.trim())"
                  >
                    <!-- A informar -->
                    <option v-if="isAInformar(p.forma_pagamento_id)" :value="null">A informar</option>

                    <!-- Normal (inclui Espécie) -->
                    <template v-else>
                      <option :value="null" disabled>Selecione</option>
                      <option v-for="c in contasFinanceiras" :key="c.id" :value="c.id">
                        {{ c.texto }}
                      </option>
                    </template>
                  </select>
                </td>

                <td v-if="showChequeCols">
                  <input
                    v-if="p.forma_pagamento_id === idCheque"
                    v-model="p.banco_numero"
                    type="text"
                    class="form-control"
                    placeholder="Banco nº"
                    :required="p.forma_pagamento_id === idCheque"
                  />
                </td>
                <td v-if="showChequeCols">
                  <input
                    v-if="p.forma_pagamento_id === idCheque"
                    v-model="p.agencia"
                    type="text"
                    class="form-control"
                    placeholder="Agência"
                    :required="p.forma_pagamento_id === idCheque"
                  />
                </td>
                <td v-if="showChequeCols">
                  <input
                    v-if="p.forma_pagamento_id === idCheque"
                    v-model="p.cheque_numero"
                    type="text"
                    class="form-control"
                    placeholder="Cheque nº"
                    :required="p.forma_pagamento_id === idCheque"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
  
      <!-- Botões de Ação -->
      <div class="form-actions d-flex justify-content-end">
        <button
          class="btn btn-primary me-2"
          :disabled="!formValid || isSubmitting"
          @click="salvarEntrada"
        >
          <i class="bi bi-save me-1"></i>
          {{ isSubmitting ? 'Salvando…' : 'Finalizar' }}
        </button>
        <button
          class="btn btn-secondary"
          :disabled="isSubmitting"
          @click="cancelar"
        >
          <i class="bi bi-x-circle me-1"></i>
          Cancelar
        </button>
      </div>
  
      <!-- Modal Fornecedor -->
      <CarregarPessoa
        :mostrar="modalFornecedorAberto"
        @fechar="fecharModalFornecedor"
        @selecionar="selecionarFornecedor"
        tipo="fornecedor"
      />
    </div>
  </template>
  
  <script setup>
  import { ref, reactive, computed, watch, watchEffect, onMounted, getCurrentInstance } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import axios from '@/services/axios';
  import { loadOperationalAccounts } from '@/services/operationalAccounts';
  import { loadLojaProducts, lojaSelectionError } from '@/services/lojaSelection';
  import CarregarPessoa from '@/components/modals/CarregarPessoa.vue';
  
  // router & context
  const router = useRouter();
  const route = useRoute();
  const { proxy, appContext } = getCurrentInstance();
  const userName = appContext.config.globalProperties.$globalState.userName;
  
  // helpers
  const hoje = new Date().toISOString().split('T')[0];

  function formatDecimal(val) {
    const num = Number(val);
    if (isNaN(num)) return '0,00';
    const parts = num.toFixed(2).split('.');       // ["1234", "56"]
    // inserção de separador de milhares
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    // junta com vírgula decimal
    return parts[0] + ',' + parts[1];
  }
  
  // estado principal
  const entrada = reactive({
    id: null,
    fornecedor_pessoa_fisica: true,
    fornecedor_id: null,
    fornecedor_nome: '',
    data_entrada: hoje,
    pendente: false,
    parcelas: 1,
    nota_fiscal: '',
    itens: []
  });
  
  // id da forma “A informar”
  const idAInformar = computed(
    () => formasPagamento.value.find(fp => fp.nome.toLowerCase() === 'a informar')?.id || null
  );
  function isAInformar(fid) {
    return fid === idAInformar.value;
  }


  // parcelamento
  const parcelasCount = ref(entrada.parcelas);
  const parcelasArray = ref([]);
  
  // dropdowns e modais
  const produtos = ref([]);
  const formasPagamento = ref([]);
  const contasFinanceiras = ref([]);
  const isSubmitting = ref(false);
  const modalFornecedorAberto = ref(false);
  
  // cheque lookup
  const idCheque = computed(() => formasPagamento.value.find(fp => fp.nome.toLowerCase() === 'cheque')?.id || null);
  const showChequeCols = computed(() => parcelasArray.value.some(p => p.forma_pagamento_id === idCheque.value));
  
  // total
  const totalEntrada = computed(() =>
    entrada.itens.reduce((sum, i) => sum + (i.subtotal || 0), 0).toFixed(2)
  );

  function onParcelaChange(p) {
    const nome = (formasPagamento.value.find(f => f.id === p.forma_pagamento_id)?.nome || '').toLowerCase();
    if (nome === 'a informar') {
      p.data_pagamento = null;
      p.conta_financeira_id = null;
    }
  }



  function onPrecoUnitInput(event, idx) {
    const raw = event.target.value
      // remove pontos de milhares
      .replace(/\./g, '')
      // troca vírgula por ponto para parse
      .replace(',', '.')
      // remove qualquer outro caractere
      .replace(/[^0-9.]/g, '');
    const num = parseFloat(raw);
    const item = entrada.itens[idx];
    item.preco_unit = isNaN(num) ? 0 : num;
    // mantém o que o usuário digitou
    item.preco_unit_str = event.target.value;
  }

  function formatPrecoUnit(idx) {
    const item = entrada.itens[idx];
    item.preco_unit_str = formatDecimal(item.preco_unit);
    item.subtotal      = +(item.quantidade * item.preco_unit).toFixed(2);
  }



  // manipulação de parcelas
  function geraParcelas(count) {
    const total = Number(totalEntrada.value) || 0;
    const base = Number((total / count).toFixed(2));
    const last = Number((total - base * (count - 1)).toFixed(2));
    const arr = [];
    for (let i = 0; i < count; i++) {
      const dt = new Date(); dt.setMonth(dt.getMonth() + i);
      const yyyy = dt.getFullYear(); const mm = String(dt.getMonth()+1).padStart(2,'0'); const dd = String(dt.getDate()).padStart(2,'0');
      arr.push({
        id: null,
        entrada_id: entrada.id,
        forma_pagamento_id: null,
        data_vencimento: `${yyyy}-${mm}-${dd}`,
        valor: i < count-1 ? base : last,
        data_pagamento: '',
        banco_numero: '',
        agencia: '',
        cheque_numero: '',
        conta_financeira_id: null
      });
    }
    parcelasArray.value = arr;
  }
  
  function toDateInputValue(iso) {
    return iso ? iso.split('T')[0] : '';
  }


  // watch & watchEffect
  watch(parcelasCount, val => { entrada.parcelas = val; geraParcelas(val); });
  watchEffect(() => {
    entrada.itens.forEach(i => { i.subtotal = +(i.quantidade * i.preco_unit).toFixed(2); });
  });
  watchEffect(() => {
    const total = Number(totalEntrada.value)||0; const count = parcelasCount.value||1;
    const base = Number((total/count).toFixed(2)); const last = Number((total-base*(count-1)).toFixed(2));
    parcelasArray.value.forEach((p,i)=> p.valor = i<count-1?base:last);
  });
  
  watch(
    () => entrada.pendente,
    (novo, antigo) => {
      // se estava pendente (true) e agora não está (false)
      if (antigo === true && novo === false) {
        // forçamos uma parcela
        parcelasCount.value = 1;
        // e geramos a linha de pagamento
        geraParcelas(1);
      }
    }
  );



  const erroProdutos = ref('');
  const erroContas = ref('');
  const produtosCarregados = ref(false);
  const contasCarregadas = ref(false);

  // inicialização
  onMounted(async () => {
    // Carregar produtos
    // Produtos ativos (pedindo muitos)
    try {
      produtos.value = await loadLojaProducts();
      produtosCarregados.value = true;
    } catch (error) {
      erroProdutos.value = lojaSelectionError(error, 'produtos');
    }

    // Carregar formas de pagamento
    try {
      const { data } = await axios.get('/cadastros/formas-pagamento');

      const norm = s => (s ?? '')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .trim().toLowerCase();

      const ordemPersonalizada = {
        'pix': 1,
        'especie': 2,
        'cartao de credito a vista': 3,
        'cartao de credito parcelado': 4,
        'cartao de debito': 5,
        'boleto': 6,
        'transferencia bancaria': 7,
        'cheque': 8,
        'a informar': 9,
      };

      formasPagamento.value = (data.data || data || [])
        .filter(fp => norm(fp.nome) !== 'brinde') // remove "Brinde"
        .map(fp => ({ id: fp.id, nome: fp.nome }))
        .sort((a, b) => {
          const oa = ordemPersonalizada[norm(a.nome)] ?? 999;
          const ob = ordemPersonalizada[norm(b.nome)] ?? 999;

          if (oa !== ob) return oa - ob;
          return a.nome.localeCompare(b.nome, 'pt-BR');
        });

    } catch (error) {
      console.error('Erro ao carregar formas de pagamento:', error);
    }

    // Carregar contas financeiras
    try {
      contasFinanceiras.value = await loadOperationalAccounts(route.params.id ? 'entrada_alteracao' : 'entrada_inclusao');
      contasCarregadas.value = true;
    } catch (error) {
      erroContas.value = lojaSelectionError(error, 'contas');
    }

    // Edição vs. criação
    if (route.params.id) {
      // Carregar cabeçalho da entrada
      try {
        const { data } = await axios.get(`/loja/entradas/${route.params.id}`);
        Object.assign(entrada, {
          id: data.entrada.id,
          fornecedor_pessoa_fisica: data.entrada.fornecedor_pessoa_fisica,
          fornecedor_id: data.entrada.fornecedor_id,
          fornecedor_nome: data.entrada.fornecedor_nome,
          data_entrada: toDateInputValue(data.entrada.data_entrada),
          pendente: data.entrada.pendente,
          parcelas: data.entrada.parcelas,
          nota_fiscal: data.entrada.nota_fiscal || ''
        });
      } catch (error) {
        console.error('Erro ao carregar dados da entrada:', error);
      }

      // Carregar itens existentes
      try {
        const respI = await axios.get('/loja/entradas/itens', { params: { entrada_id: entrada.id } });
        entrada.itens = respI.data.map(i => ({
          produto_id: i.produto_id,
          quantidade: i.quantidade,
          preco_unit: parseFloat(i.preco_unit),
          subtotal: parseFloat(i.subtotal),
          preco_unit_str: formatDecimal(i.preco_unit)
        }));
      } catch (error) {
        console.error('Erro ao carregar itens da entrada:', error);
        entrada.itens = [];
      }

      // Carregar pagamentos existentes
      try {
        const respP = await axios.get('/loja/entradas/pagamentos', { params: { entrada_id: entrada.id } });
        parcelasCount.value = entrada.parcelas;
        parcelasArray.value = respP.data.map(p => ({
          id: p.id,
          entrada_id: p.entrada_id,
          forma_pagamento_id: p.forma_pagamento_id,
          data_vencimento: toDateInputValue(p.data_vencimento),
          valor: Number(p.valor),
          data_pagamento: p.data_pagamento ? toDateInputValue(p.data_pagamento) : '',
          banco_numero: p.banco_numero,
          agencia: p.agencia,
          cheque_numero: p.cheque_numero,
          conta_financeira_id: p.conta_financeira_id
        }));
      } catch (error) {
        console.error('Erro ao carregar pagamentos da entrada:', error);
        geraParcelas(parcelasCount.value);
      }

    } else {
      // Novo registro
      adicionarItem();
      geraParcelas(parcelasCount.value);
    }
  });
  
  // ações do modal fornecedor
  function abrirModalFornecedor(){ 
    modalFornecedorAberto.value=true; 
  }

  function fecharModalFornecedor(){ 
    modalFornecedorAberto.value=false; 
  }
  
  function selecionarFornecedor({id,nome,tipo}){ 
    entrada.fornecedor_id=id; 
    entrada.fornecedor_nome=nome; 
    entrada.fornecedor_pessoa_fisica=(tipo==='fisica'); 
    fecharModalFornecedor(); 
  }
  
  // itens de entrada
  function adicionarItem() {
    entrada.itens.push({
      produto_id: null,
      quantidade: 1,
      preco_unit: 0,
      subtotal: 0,
      // novo campo
      preco_unit_str: '0,00'
    });
  }
  function removerItem(idx){ 
    entrada.itens.splice(idx,1); 
  }

  function selecionarProduto(idx) {
    const item = entrada.itens[idx];
    const prod = produtos.value.find(p => p.id === item.produto_id);
    if (prod) {
      item.preco_unit = prod.preco;
    } else {
      item.preco_unit = 0;
    }
    item.preco_unit_str = formatDecimal(item.preco_unit);
  }
  
  const formValid = computed(() => {
    if (!produtosCarregados.value || !contasCarregadas.value || erroProdutos.value || erroContas.value) return false;
    // validação inicial
    if (!entrada.fornecedor_id || !entrada.data_entrada) return false;
    if (!entrada.itens.length) return false;
    if (!entrada.itens.every(i => i.produto_id && i.quantidade > 0)) return false;
    if (parcelasArray.value.some(p => p.conta_financeira_id != null &&
      !contasFinanceiras.value.some(c => c.id === Number(p.conta_financeira_id)))) return false;
    if (entrada.pendente) return true;

    // valida cada parcela
    const tudoOk = parcelasArray.value.every(p => {
      const nome = (formasPagamento.value.find(f => f.id === p.forma_pagamento_id)?.nome || '').toLowerCase();

      // 1) forma e vencimento são sempre obrigatórios
      if (!p.forma_pagamento_id || !p.data_vencimento) return false;

      // 2) pagamento é obrigatório, exceto "A informar"
      if (nome !== 'a informar' && !p.data_pagamento) return false;

      // conta financeira: só exige se houver data_pagamento (inclui Espécie)
      if (nome !== 'a informar' && (p.data_pagamento || '').trim() && !p.conta_financeira_id) {
        return false;
      }

      return true;
    });
    if (!tudoOk) return false;

    // 4) dados de cheque continuam obrigatórios quando for cheque
    for (const p of parcelasArray.value) {
      if (p.forma_pagamento_id === idCheque.value) {
        if (!p.banco_numero || !p.agencia || !p.cheque_numero) {
          return false;
        }
      }
    }

    return true;
  });
  
  // salvar
  async function salvarEntrada(){ 
    if(isSubmitting.value || !formValid.value)
      return; 
    isSubmitting.value=true; 
    try{ 
      const payload={ 
        fornecedor_pessoa_fisica:entrada.fornecedor_pessoa_fisica, 
        fornecedor_id:entrada.fornecedor_id, 
        data_entrada:entrada.data_entrada, 
        valor_total:parseFloat(totalEntrada.value), 
        pendente:entrada.pendente, 
        por:userName, 
        parcelas:parcelasCount.value, 
        nota_fiscal:entrada.nota_fiscal,
        itens:entrada.itens.map(i=>({
          produto_id:i.produto_id, 
          quantidade:i.quantidade, 
          preco_unit:i.preco_unit, 
          subtotal:i.subtotal
        })), 
        pagamentos:parcelasArray.value.map(p=>({
          forma_pagamento_id:p.forma_pagamento_id, 
          data_vencimento:p.data_vencimento, 
          valor:p.valor, 
          data_pagamento:p.data_pagamento||null, 
          banco_numero:p.banco_numero||null, 
          agencia:p.agencia||null, 
          cheque_numero:p.cheque_numero||null, 
          conta_financeira_id:p.conta_financeira_id||null
        }))
      }; 
      if(entrada.id){ 
        await axios.put(`/loja/entradas/${entrada.id}`,payload); 
      } else { 
        const res=await axios.post('/loja/entradas',payload); 
        entrada.id=res.data.id; 
      } 
      router.push('/loja/entradas'); 
    }catch(err){ 
      console.error('Erro ao salvar entrada:',err); 
      proxy.$alert(err.response?.data?.error || 'Erro ao salvar entrada. Verifique os dados e tente novamente.','Erro');
    } 
    finally{ isSubmitting.value=false; } 
  }

  function cancelar(){ router.push('/loja/entradas'); }
  </script>
  
  <style scoped>
  .spacer { margin-bottom: 1rem; }
  .section-title { font-weight: bold; margin-bottom: .5rem; font-size: 1rem; }
  .required { color: red; }
  .disabled-input { background: #e9ecef; }
  .form-actions { margin-top: 1.5rem; }
  </style>
  